(function () {
  'use strict';

  var root = null;
  var drawer = null;
  var contentEl = null;
  var loadingEl = null;
  var productData = null;
  var chartData = null;
  var currentUnit = 'in';
  var selectedSize = null;
  var selectedVariantId = null;
  var isOpen = false;
  var eventsBound = false;

  function getPanel() {
    if (!contentEl) return null;
    return contentEl.querySelector('[data-sg-fclo-panel]');
  }

  function formatMoney(cents) {
    var currency = (window.theme && window.theme.shopCurrency) || 'INR';
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return '₹ ' + (cents / 100).toFixed(2);
    }
  }

  function formatValue(value, unit) {
    var num = parseFloat(value);
    if (isNaN(num)) return value;
    if (unit === 'cm') {
      return (num * 2.54).toFixed(1);
    }
    return num.toFixed(1);
  }

  function setLoading(show) {
    if (loadingEl) loadingEl.hidden = !show;
  }

  function showError(message) {
    var panel = getPanel();
    var errorEl = (panel && panel.querySelector('[data-sg-fclo-error]'))
      || (root && root.querySelector('[data-sg-fclo-error-global]'));
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function normalizeSize(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, '').replace(/years?/g, 'y');
  }

  function lockScroll() {
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', {
      bubbles: true,
      detail: drawer
    }));
  }

  function unlockScroll() {
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
  }

  function openDrawer() {
    if (!root || isOpen) return;
    isOpen = true;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
    lockScroll();
    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer() {
    if (!root || !isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    unlockScroll();
    document.removeEventListener('keydown', onKeydown);
    setTimeout(function () {
      if (!isOpen) {
        root.hidden = true;
        if (contentEl) contentEl.innerHTML = '';
        productData = null;
        chartData = null;
        selectedSize = null;
        selectedVariantId = null;
        currentUnit = 'in';
      }
    }, 300);
  }

  function onKeydown(event) {
    if (event.key === 'Escape') closeDrawer();
  }

  function getOptionName(option) {
    if (!option) return '';
    if (typeof option === 'string') return option;
    if (typeof option === 'object' && option.name) return String(option.name);
    return String(option);
  }

  function getSizeOptionIndex() {
    if (!productData || !productData.options) return -1;
    for (var i = 0; i < productData.options.length; i++) {
      var name = getOptionName(productData.options[i]).toLowerCase();
      if (name === 'size') return i;
    }
    return -1;
  }

  function findVariantBySize(sizeLabel) {
    if (!productData || !productData.variants || !sizeLabel) return null;
    var sizeIndex = getSizeOptionIndex();
    if (sizeIndex < 0) return null;

    var normalized = normalizeSize(sizeLabel);
    return productData.variants.find(function (variant) {
      var opt = normalizeSize(variant.options[sizeIndex]);
      return opt === normalized || opt.indexOf(normalized) > -1 || normalized.indexOf(opt) > -1;
    });
  }

  function updateVariantState(panel) {
    var variant = selectedVariantId
      ? productData.variants.find(function (v) { return v.id === selectedVariantId; })
      : findVariantBySize(selectedSize);

    if (!variant && productData.variants.length) {
      variant = productData.variants.find(function (v) { return v.available; }) || productData.variants[0];
    }

    if (!variant) return;

    selectedVariantId = variant.id;
    var hidden = panel.querySelector('[data-sg-fclo-variant-id]');
    var priceEl = panel.querySelector('[data-sg-fclo-price]');
    var addBtn = panel.querySelector('[data-sg-fclo-add-to-cart]');
    var buyBtn = panel.querySelector('[data-sg-fclo-buy-now]');

    if (hidden) hidden.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    var soldOut = !variant.available;
    if (addBtn) {
      addBtn.disabled = soldOut;
      addBtn.textContent = soldOut ? 'Sold out' : 'Add to Cart';
    }
    if (buyBtn) buyBtn.disabled = soldOut;
  }

  function renderTable(panel) {
    if (!chartData || !chartData.rows) return;

    var thead = panel.querySelector('[data-sg-fclo-table-head]');
    var tbody = panel.querySelector('[data-sg-fclo-table-body]');
    if (!thead || !tbody) return;

    var columns = chartData.columns || [];
    var headHtml = '<tr><th>Size</th>';
    columns.forEach(function (col) {
      headHtml += '<th>' + col.label + '</th>';
    });
    headHtml += '</tr>';
    thead.innerHTML = headHtml;

    var bodyHtml = '';
    chartData.rows.forEach(function (row, index) {
      var isSelected = selectedSize && row.size === selectedSize;
      bodyHtml += '<tr data-sg-fclo-row data-size="' + escapeAttr(row.size) + '" class="' + (isSelected ? 'is-selected' : '') + '">';
      bodyHtml += '<td><div class="sg-fclo__size-cell"><span class="sg-fclo__radio" aria-hidden="true"></span><span>' + escapeHtml(row.size) + '</span></div></td>';
      columns.forEach(function (col) {
        bodyHtml += '<td>' + formatValue(row[col.key], currentUnit) + '</td>';
      });
      bodyHtml += '</tr>';
    });
    tbody.innerHTML = bodyHtml;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function getConfig() {
    return window.SizeGuideFcloConfig || {
      sectionId: 'api-size-guide-fclo',
      defaultDataUrl: ''
    };
  }

  function loadChartData(panel) {
    var raw = panel.getAttribute('data-size-guide-json');
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (parsed && parsed.rows && parsed.rows.length) {
          return Promise.resolve(parsed);
        }
      } catch (e) {
        console.warn('Size guide JSON parse error:', e);
      }
    }

    var defaultDataUrl = getConfig().defaultDataUrl;
    if (!defaultDataUrl) {
      return Promise.reject(new Error('Size guide data is not configured'));
    }

    return fetch(defaultDataUrl)
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Size guide data missing. Upload assets/size-guide-fclo-default.json to your theme.');
        }
        return res.json();
      });
  }

  function refreshCartAndOpenSidebar() {
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart)
      ? window.theme.routes.cart + '.js'
      : '/cart.js';

    return fetch(cartUrl)
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cart },
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (cartDrawer) {
          cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
        }
      });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) || 1 })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          var message = err.description || err.message || 'Could not add to cart';
          if (/cannot find variant/i.test(message)) {
            message = 'Sold out';
          }
          throw new Error(message);
        });
      }
      return res.json();
    });
  }

  function initPanel(panel) {
    selectedSize = null;
    currentUnit = 'in';

    panel.querySelectorAll('[data-sg-fclo-unit]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-sg-fclo-unit') === 'in');
    });

    return loadChartData(panel).then(function (data) {
      chartData = data;
      if (chartData.rows && chartData.rows.length) {
        selectedSize = chartData.rows[0].size;
      }
      renderTable(panel);
      updateVariantState(panel);
    });
  }

  function handleContentClick(event) {
    if (!contentEl || !contentEl.contains(event.target)) return;
    var panel = getPanel();
    if (!panel) return;

    var unitBtn = event.target.closest('[data-sg-fclo-unit]');
    if (unitBtn) {
      event.preventDefault();
      currentUnit = unitBtn.getAttribute('data-sg-fclo-unit');
      panel.querySelectorAll('[data-sg-fclo-unit]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn === unitBtn);
      });
      renderTable(panel);
      return;
    }

    var row = event.target.closest('[data-sg-fclo-row]');
    if (row) {
      event.preventDefault();
      selectedSize = row.getAttribute('data-size');
      panel.querySelectorAll('[data-sg-fclo-row]').forEach(function (r) {
        r.classList.toggle('is-selected', r === row);
      });
      updateVariantState(panel);
      return;
    }

    var addBtn = event.target.closest('[data-sg-fclo-add-to-cart]');
    if (addBtn) {
      event.preventDefault();
      if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;
      var variantInput = panel.querySelector('[data-sg-fclo-variant-id]');
      if (!variantInput || !variantInput.value) {
        showError('Please select a size');
        return;
      }
      addBtn.classList.add('is-loading');
      showError('');
      addToCart(variantInput.value, 1)
        .then(function () {
          closeDrawer();
          return refreshCartAndOpenSidebar();
        })
        .catch(function (err) {
          showError(err.message || 'Something went wrong');
        })
        .finally(function () {
          addBtn.classList.remove('is-loading');
        });
      return;
    }

    var buyBtn = event.target.closest('[data-sg-fclo-buy-now]');
    if (buyBtn) {
      event.preventDefault();
      if (buyBtn.disabled || buyBtn.classList.contains('is-loading')) return;
      var buyVariantInput = panel.querySelector('[data-sg-fclo-variant-id]');
      if (!buyVariantInput || !buyVariantInput.value) {
        showError('Please select a size');
        return;
      }
      buyBtn.classList.add('is-loading');
      showError('');
      addToCart(buyVariantInput.value, 1)
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          showError(err.message || 'Something went wrong');
          buyBtn.classList.remove('is-loading');
        });
    }
  }

  function open(handle) {
    if (!contentEl) return Promise.reject();

    setLoading(true);
    showError('');
    openDrawer();

    var cfg = getConfig();
    var rootUrl = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    var sectionUrl = rootUrl + 'products/' + handle + '?section_id=' + cfg.sectionId;
    var productUrl = rootUrl + 'products/' + handle + '.js';

    return Promise.all([
      fetch(sectionUrl).then(function (res) {
        if (!res.ok) throw new Error('Product not found');
        return res.text();
      }),
      fetch(productUrl).then(function (res) {
        if (!res.ok) throw new Error('Product data not found');
        return res.json();
      })
    ])
      .then(function (results) {
        productData = results[1];
        var doc = new DOMParser().parseFromString(results[0], 'text/html');
        var apiContent = doc.querySelector('[data-api-content]');
        if (!apiContent) throw new Error('Size guide content missing');

        contentEl.innerHTML = apiContent.innerHTML;
        var panel = getPanel();
        if (!panel) throw new Error('Size guide panel missing');

        return initPanel(panel);
      })
      .catch(function (err) {
        showError(err.message || 'Could not load size guide');
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function bindGlobal() {
    var roots = document.querySelectorAll('[data-sg-fclo-root]');
    if (!roots.length) return;

    root = Array.prototype.find.call(roots, function (node) {
      return node.getAttribute('data-sg-fclo-mode') === 'modal';
    }) || roots[0];

    if (root && root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    var sizeChartModal = document.getElementById('qv-fclo-size-chart-modal');
    if (sizeChartModal && sizeChartModal.parentElement !== document.body) {
      document.body.appendChild(sizeChartModal);
    }

    Array.prototype.forEach.call(roots, function (node) {
      if (node !== root && node.parentNode) {
        node.parentNode.removeChild(node);
      }
    });

    drawer = root.querySelector('[data-sg-fclo-drawer]');
    contentEl = root.querySelector('[data-sg-fclo-content]');
    loadingEl = root.querySelector('[data-sg-fclo-loading]');

    var overlay = root.querySelector('[data-sg-fclo-overlay]');
    var closeBtn = root.querySelector('[data-sg-fclo-close]');
    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    if (!eventsBound && contentEl) {
      contentEl.addEventListener('click', handleContentClick);
      eventsBound = true;
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-sg-fclo-open]');
      if (!trigger) return;
      event.preventDefault();
      var handle = trigger.getAttribute('data-product-handle');
      if (handle) open(handle);
    });
  }

  window.SizeGuideFclo = {
    open: open,
    close: closeDrawer
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindGlobal);
  } else {
    bindGlobal();
  }
})();
